interface LiteModeNoticeProps {
  feature?: string
  description?: string
}

export function LiteModeNotice({ feature, description }: LiteModeNoticeProps) {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] p-8">
      <div className="max-w-md text-center space-y-4 border border-amber-200 dark:border-amber-800 bg-amber-50 dark:bg-amber-950/30 rounded-lg p-6">
        <div className="text-amber-700 dark:text-amber-300 text-lg font-semibold">
          Feature unavailable in lite mode
        </div>
        {feature && (
          <div className="text-sm text-amber-600 dark:text-amber-400">
            <span className="font-mono">{feature}</span> requires DOCTRINE_MODE=full
          </div>
        )}
        <div className="text-sm text-gray-600 dark:text-gray-400">
          {description ?? 'This page depends on services that are disabled in the current runtime mode. Restart the server with `pnpm dev` (full mode) to enable this feature.'}
        </div>
      </div>
    </div>
  )
}
